import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HlsOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hls_off"}/>
}
